import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Payment() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [txnId, setTxnId] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const [errors, setErrors] = useState({});

  const planPrices = {
    starter: 499,
    pro: 999,
    premium: 1499,
  };

  const selectedTemplate =
    state?.template?.toLowerCase() in planPrices
      ? state.template.toLowerCase()
      : "premium";

  const price = planPrices[selectedTemplate];

  const upiId = "nitinsatya656@oksbi";
  const name = "Nitin Satya";
  const encodedName = encodeURIComponent(name);

  const upiLink = `upi://pay?pa=${upiId}&pn=${encodedName}&cu=INR&am=${price}`;

  const handleScreenshotUpload = (e) => {
    const file = e.target.files[0];
    if (file) setScreenshot(file);
  };

  const handleFinalSubmit = async () => {
    const newErrors = {};
    if (!phone) newErrors.phone = "Phone number is required";
    if (!txnId) newErrors.txnId = "Transaction ID is required";
    if (!screenshot) newErrors.screenshot = "Payment screenshot is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length) {
      toast.error("⚠️ Please fix the errors and try again.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append(
      "data",
      JSON.stringify({
        ...(state || {}),
        phone,
        txnId,
        template: selectedTemplate,
        price,
      })
    );
    formDataToSend.append("screenshot", screenshot);

    try {
      const res = await fetch("http://localhost:5001/submit-payment", {
        method: "POST",
        body: formDataToSend,
      });

      const result = await res.json();
      if (result.success) {
        toast.success("✅ Payment & form submitted successfully!");
        setTimeout(() => navigate("/success"), 1500);
      } else {
        toast.error("❌ Error submitting form.");
      }
    } catch (err) {
      console.error("Submission error:", err);
      toast.error("❌ Something went wrong.");
    }
  };

  return (
    <div className="min-h-screen bg-white text-zinc-900 px-6 py-10 dark:bg-zinc-900 dark:text-white">
  <ToastContainer />
  <div className="max-w-3xl mx-auto bg-white/80 dark:bg-black/80 p-8 rounded-2xl space-y-6 shadow-2xl border border-primary">
    <h2 className="text-3xl md:text-4xl font-bold text-hoverBlue text-center">
      Confirm Payment for {selectedTemplate.toUpperCase()} Plan
    </h2>

    <p className="text-center text-2xl text-green-600 dark:text-green-400 font-semibold">
      ₹{price} to be paid
    </p>

    <div className="space-y-6 mt-6">
      <div>
        <label htmlFor="phone" className="block text-sm mb-1">
          📞 Phone Number *
        </label>
        <input
          id="phone"
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Enter your phone number"
          className="w-full px-4 py-2 rounded bg-zinc-100 dark:bg-background text-zinc-900 dark:text-white border border-primary focus:outline-none focus:ring-2 focus:ring-hoverBlue"
          required
        />
        {errors.phone && (
          <p className="text-red-600 dark:text-red-400 text-sm mt-1">{errors.phone}</p>
        )}
      </div>

      <div>
        <label htmlFor="txnId" className="block text-sm mb-1">
          🆔 Transaction ID *
        </label>
        <input
          id="txnId"
          type="text"
          value={txnId}
          onChange={(e) => setTxnId(e.target.value)}
          placeholder="Transaction ID from UPI/Bank"
          className="w-full px-4 py-2 rounded bg-zinc-100 dark:bg-background text-zinc-900 dark:text-white border border-primary focus:outline-none focus:ring-2 focus:ring-hoverBlue"
          required
        />
        {errors.txnId && (
          <p className="text-red-600 dark:text-red-400 text-sm mt-1">{errors.txnId}</p>
        )}
      </div>

      <div>
        <label htmlFor="screenshot" className="block text-sm mb-1">
          📷 Upload Payment Screenshot *
        </label>
        <input
          id="screenshot"
          type="file"
          accept="image/*"
          onChange={handleScreenshotUpload}
          className="block w-full file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-hoverBlue file:text-white hover:file:bg-primary"
          required
        />
        {errors.screenshot && (
          <p className="text-red-600 dark:text-red-400 text-sm mt-1">{errors.screenshot}</p>
        )}
      </div>
    </div>

    <div className="mt-8 text-center">
      <h3 className="text-lg font-semibold text-hoverBlue mb-2">Scan & Pay</h3>
      <div className="flex justify-center">
        <QRCode value={upiLink} size={180} bgColor="#0a0a0a" fgColor="#66ccff" />
      </div>
      <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">UPI ID: {upiId}</p>

      <div className="flex flex-wrap justify-center gap-4 mt-4 text-sm">
        <a href={upiLink} className="underline text-primary hover:text-hoverBlue">
          Pay via GPay
        </a>
        <a
          href={`phonepe://pay?pa=${upiId}&pn=${encodedName}&am=${price}&cu=INR`}
          className="underline text-primary hover:text-hoverBlue"
        >
          PhonePe
        </a>
        <a
          href={`paytmmp://pay?pa=${upiId}&pn=${encodedName}&am=${price}&cu=INR`}
          className="underline text-primary hover:text-hoverBlue"
        >
          Paytm
        </a>
      </div>
    </div>

    <button
      onClick={handleFinalSubmit}
      className="w-full mt-10 bg-primary hover:bg-buttonHover text-white py-3 rounded-full font-bold transition duration-200"
    >
      Submit Payment & Finish
    </button>
  </div>
</div>

  );
}
